var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 121,
    viewBox: "0 0 65 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5962 112.039C45.346 117.312 37.6004 120.13 29.6247 120.13C28.3976 120.13 26.9213 120.13 25.5793 119.881C15.878 118.769 6.92453 113.247 0.310059 104.063L5.58247 100.267C11.2192 108.243 18.2171 112.423 26.327 113.515C34.0535 114.493 41.3006 112.173 47.1865 107.016C60.1854 95.8576 61.5467 74.6338 50.1391 61.1364C44.8667 54.8862 37.3703 51.3202 29.2795 51.3202C21.1888 51.3202 13.3281 54.637 7.55722 61.1364L1.92053 67.6359V0.129883H57.5013V6.62932H8.42V51.416C12.7146 47.7349 20.8053 44.6674 29.2795 44.7824C39.0958 44.8974 48.6628 49.4413 55.1622 57.0527C68.5446 72.8891 66.8191 98.6376 51.5962 112.02V112.039Z",
    fill: "#231F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber5);
export default __webpack_public_path__ + "static/media/NUMBER_5.c3689e658b3b16532e0ab7f585312c1e.svg";
export { ForwardRef as ReactComponent };